import { defineComponent, nextTick, ref } from "vue";
import InputText from "../../forms/InputText";
import UploadBox from "../../components/UploadBox";
import Offers from "../../components/Offers";
import Utils from "../../utils/Utils";
import { OfferJson } from "../../OrderForm";
import OfferUtils from "../../utils/OfferUtils";

export default defineComponent({
    components: {
        InputText,
        Offers,
        UploadBox,
    },

    template: `
        <div class="StepOffers">
            <h1 v-if="label_title" class="title-1">{{ label_title }}</h1>
            <h1 v-if="!label_title && !tariff" class="title-1">Wszystkie taryfy</h1>

            <h2 v-if="label_subtitle" class="StepOffers__subtitle title-3">{{ label_subtitle }}</h2>

            <Offers
                v-if="offers"
                :offers="offers"

                @offer:click="onOfferClick($event)"
            />
        </div>
    `,

    emits: [
        'offer:select',
    ],

    mounted() {
        nextTick(() => {
            Utils.scrollToEl($('.StepOffers'));
        });
    },

    props: {
        /** @var OrderJson */
        options: { type: Object, required: true },

        tariff: { type: String },

        label_title: { type: String },
        label_subtitle: { type: String },
    },

    setup(props, ctx) {
        const offers = ref(null as OfferJson[]);

        async function reload() {
            offers.value = await OfferUtils.fetchOffers(props.tariff);
        }

        async function onOfferClick(offer: OfferJson) {
            await Utils.setCart('offer', {
                offer_id: offer.id,
            });

            ctx.emit('offer:select', offer);
        }

        reload();

        return {
            offers,

            reload,
            onOfferClick,
        };
    },
});
